import styled from 'styled-components'
import { softGray } from '../../../styles/variables.js'

const Levels = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: ${softGray};
  margin-bottom: 15px;
  border-radius: 4px;
`

const Title = styled.div`
  font-size: 20px;
  text-transform: capitalize;
  margin-left: 10px;
  margin-bottom: 10px;
`

const LevelValues = styled.div`
  display: flex;
  flex-direction: row;
  & > div {
    margin: 0 10px;
  }
`

const ItemFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

export default {
  LevelValues,
  Title,
  Levels,
  ItemFooter,
}
